module.exports = __webpack_public_path__ + "static/media/управление стрессом.64046006.jpg";